export default __webpack_public_path__ + "static/media/Doors_Windows_Flooring.27ee87bf.svg";